<template>
    <v-menu
        open-on-hover
        bottom
        offset-y
    >
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind="attrs"
                v-on="on"
            >
                <c-tag
                    :label     = "label"
                    :active    = "active"
                    :highlight = "highlight"
                    class      = "mr-1"
                />
            </a>
        </template>

        <div class="pa-3 white">
            <company-card
                class="card-tooltip"
                :company = "company"
            />
        </div>
    </v-menu>
</template>

<script>
import CTag from "@/modules/core/components/utils/CTag";
import CompanyCard from "@/modules/msd/company/common/components/controlls/CompanyCard";

export default {
    name: "CompanyTag",

    components: {
        CompanyCard,
        CTag
    },

    props: {
        label: {
            required: true,
        },

        active: {

        },
        company: {

        },

        highlight: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        }
    },
}
</script>

<style scoped>

.card-tooltip {
    width: 350px;
}

</style>